<template>
  <nav aria-label="breadcrumb" class="breadcrumb-container">
    <ol v-if="!loading" class="breadcrumb">
      <template v-for="(link, l) in links">
        <li class="breadcrumb-item" :key="l" v-if="l + 1 < links.length">
          <router-link :to="{ name: link.routeName }">{{ link.name }}</router-link>
        </li>
        <li class="breadcrumb-item active" :key="l" v-else aria-current="page">{{ link.name }}</li>
      </template>
    </ol>
    <div v-if="loading" class="breadcrumb-container">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><div class="loading-block breadcrumb-loading-block"></div></li>
        <li class="breadcrumb-item"><div class="loading-block breadcrumb-loading-block"></div></li>
      </ol>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    links: Array,
    loading: Boolean,
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss">
@import "~@/styles/variables";
</style>
